export default __webpack_public_path__ + "static/media/04_Blueprint.1a5c6e50.mp3";